export default __webpack_public_path__ + "static/media/google-icon.35bcce80.png";